import React from 'react';
import PropTypes from 'prop-types';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box, Grid, Modal, Typography } from '@mui/material';

import Button from '../../../../components/Button';
import { PRIMARY_COLOR } from '../../../../theme/colorConstants';
import {
  capitalizeFirstLetter,
  epochToDateInReadableFormat,
  epochToTimeInReadableFormat,
} from '../../../../utils';

import {
  modalBodyContentStyle,
  modalBodyTimeContentStyle,
  modalTitleStyles,
  rootGridStyles,
} from './timecardNotesModalStyles';

const TimecardNotesModal = ({ isOpen, handleOnClose, attendance, handleOnClick }) => (
  <Modal
    open={isOpen}
    onClose={handleOnClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    data-testid="map-modal"
  >
    <Grid container item xs direction="column" sx={rootGridStyles}>
      <Typography sx={modalTitleStyles}>
        {LanguageConverter('timekeeping.modal.noteTitle')}
      </Typography>
      <Box>
        {attendance?.leftEarlyReason?.note && (
          <Grid
            sx={{
              marginBottom: attendance?.sentHomeReason?.note && 4,
            }}
          >
            <Typography sx={modalBodyContentStyle}>{`${
              attendance?.leftEarlyReason?.user?.name
            } (${capitalizeFirstLetter(UserRole.CANDIDATE)})`}</Typography>
            <Typography sx={modalBodyTimeContentStyle}>{`${epochToDateInReadableFormat(
              attendance?.leftEarlyReason?.timestamp
            )} at ${epochToTimeInReadableFormat(
              attendance?.leftEarlyReason?.timestamp
            )}`}</Typography>
            <Typography sx={modalBodyContentStyle}>{attendance?.leftEarlyReason?.note}</Typography>
          </Grid>
        )}
        {attendance?.sentHomeReason?.note && (
          <Grid>
            <Typography sx={modalBodyContentStyle}>{`${
              attendance?.sentHomeReason?.user?.name
            } (${capitalizeFirstLetter(UserRole.EMPLOYER)})`}</Typography>
            <Typography sx={modalBodyTimeContentStyle}>{`${epochToDateInReadableFormat(
              attendance?.sentHomeReason?.timestamp
            )} at ${epochToTimeInReadableFormat(
              attendance?.sentHomeReason?.timestamp
            )}`}</Typography>
            <Typography sx={modalBodyContentStyle}>{attendance?.sentHomeReason?.note}</Typography>
          </Grid>
        )}
      </Box>
      <Grid container item direction="row" sx={{ justifyContent: 'flex-end' }}>
        <Button
          data-testid="timekeepingModalOnClick"
          text={LanguageConverter('timekeeping.modal.button')}
          onClick={handleOnClick}
          sx={{
            backgroundColor: PRIMARY_COLOR[70],
            height: 40,
            width: 121,
            marginTop: 5,
          }}
        />
      </Grid>
    </Grid>
  </Modal>
);
TimecardNotesModal.propTypes = {
  isOpen: PropTypes.bool,
  handleOnClose: PropTypes.func,
  handleOnClick: PropTypes.func,
  attendance: PropTypes.shape({
    leftEarlyReason: PropTypes.shape({
      user: PropTypes.shape({
        name: PropTypes.string,
        role: PropTypes.string,
      }),
      timestamp: PropTypes.number,
      note: PropTypes.string,
    }),
    sentHomeReason: PropTypes.shape({
      user: PropTypes.shape({
        name: PropTypes.string,
        role: PropTypes.string,
      }),
      timestamp: PropTypes.number,
      note: PropTypes.string,
    }),
  }),
};

export default TimecardNotesModal;
